export const environment = {
  production: false,
  nonprod: true
};
